/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { VideoManager } from '../../../core/videoplayer';
import { Locale } from '../../../core/locale/Locale';
import { LocaleKeys } from '../../../core/locale/LocaleKeys';
import { NetworkManager } from '../../../core/network/NetworkManager';
import { ServicesClientImpl } from '../../../core/impls/ServicesClientImpl';
import { BrandingUiInfoKeys } from '../../../core/entities/BrandingUiInfoKeys';
import { showVideoDebugOverlay } from '../../videoplayer/videodebugoverlay/videodebugoverlay.reducers';
import { ACTION_STRIP_HIGHLIGHT_LEFT_OFFSET } from '../../../config';
import { showSubtitleAndCCLanguageOverlay } from '../../videoplayer/overlays/subtitleandcclanguageoverlay/subtitleandcclanguageoverlay.reducers';
import { toggleIsPlaying } from '../../videoplayer/videoplayer.reducers';
import { showAudioTrackOverlay } from '../../videoplayer/overlays/audiotrackoverlay/audiotrackoverlay.reducers';
import {
    hideFullInfo,
    hideInfoBanners,
    setActionsStripHighlightIndex,
} from './infobanner.reducers';
import { prepareVodResumeStartOverOverlayFromLiveTv } from '../../overlay/vodresumestartoveroverlay/vodresumestartoveroverlay.reducers';
import { DimensionScaler } from '../../../core/device/DimensionScaler';

export const onKeyLeftActionsStrip = () => (dispatch: Function, getState: Function) => {
    const { infoBanner } = getState();
    const { actionsStripHighlightIndex, actionStripReference } = infoBanner;
    if (actionsStripHighlightIndex > 0) {
        dispatch(setActionsStripHighlightIndex(actionsStripHighlightIndex - 1));

        if (actionStripReference && actionStripReference.current) {
            let requiredMargin = 0;
            const childrens = actionStripReference.current.children;

            for (let i = 0; i < actionsStripHighlightIndex - 1; i += 1) {
                requiredMargin -= childrens[i].clientWidth;
            }

            // TODO: This is a temporary fix need to change once common functionality is implemented
            actionStripReference.current.style.marginLeft = `${
                requiredMargin +
                DimensionScaler.getInstance().getScaledWidth(ACTION_STRIP_HIGHLIGHT_LEFT_OFFSET)
            }px`;
        }
    }
};

export const onKeyOkActionsStrip = () => async (dispatch: Function, getState: Function) => {
    dispatch(hideFullInfo());
    if (NetworkManager.isNetworkDisconnected()) return;
    const { availableActionItems, actionsStripHighlightIndex } = getState().infoBanner;
    const services = new ServicesClientImpl();
    switch (availableActionItems[actionsStripHighlightIndex].name) {
        case Locale.getString(LocaleKeys.LIVE_TV_ACTION_STRIP_CHANGE_AUDIO_TRACK):
            dispatch(showAudioTrackOverlay());
            break;
        case Locale.getString(LocaleKeys.LIVE_TV_ACTION_STRIP_CHANGE_SUBTITLES_CC_LANGUAGE):
            dispatch(showSubtitleAndCCLanguageOverlay());
            break;
        case services.getBrandingUiInfoForKey(BrandingUiInfoKeys.START_OVER):
            dispatch(hideInfoBanners());
            dispatch(prepareVodResumeStartOverOverlayFromLiveTv());
            break;
        case Locale.getString(LocaleKeys.LIVE_TV_ACTION_STRIP_RESUME):
            if (
                VideoManager.getInstance().getVideoPlayerModel().isPlaybackStarted() &&
                !NetworkManager.isNetworkDisconnected()
            ) {
                dispatch(toggleIsPlaying());
            }
            break;
        case Locale.getString(LocaleKeys.LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_ON):
        case Locale.getString(LocaleKeys.LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_OFF):
            VideoManager.getInstance().getVideoPlayerModel().toggleClosedCaption();
            break;
        case Locale.getString(LocaleKeys.LIVE_TV_STREAM_STATS):
            dispatch(showVideoDebugOverlay());
            break;

        default:
        // callback to default case
    }
};

export const onKeyRightActionsStrip = () => (dispatch: Function, getState: Function) => {
    const { infoBanner } = getState();
    const { actionsStripHighlightIndex, actionItemsCount, actionStripReference } = infoBanner;
    if (actionsStripHighlightIndex < actionItemsCount - 1) {
        dispatch(setActionsStripHighlightIndex(actionsStripHighlightIndex + 1));
        if (actionStripReference && actionStripReference.current) {
            let requiredMargin = 0;
            const childrens = actionStripReference.current.children;

            for (let i = 0; i <= actionsStripHighlightIndex; i += 1) {
                requiredMargin -= childrens[i].clientWidth;
            }

            // TODO: This is a temporary fix need to change once common functionality is implemented
            actionStripReference.current.style.marginLeft = `${
                requiredMargin +
                DimensionScaler.getInstance().getScaledWidth(ACTION_STRIP_HIGHLIGHT_LEFT_OFFSET)
            }px`;
        }
    }
};
